@if (lang === 'en' || lang === 'EN') {
  <ion-content>
    <div class=WordSection1>
      <p class=MsoNormal>Privacy Policy &amp; Terms of Use</p>
      <p class=MsoNormal>INTRODUCTION</p>
      <p class=MsoNormal>SHOP ACHAT has created this privacy and terms of use
        statement to demonstrate our firm commitment to your privacy and use as an
        activated and registered member of the SHOP ACHAT secured website. The
        following discloses our information gathering and dissemination practices for
      the SHOP ACHAT secured website.</p>
      <p class=MsoNormal>SHOP ACHAT understands and respects your concerns about
        privacy. At the same time, we do ask that you provide information about
        yourself in order for us to understand your needs better and make your
        experience at SHOP ACHAT more valuable to you. We created this Privacy Policy
        to provide you with notice of what information SHOP ACHAT may collect, how such
        information may be used or shared with third parties, and how such information
        relates to the operation of the site. This Privacy Policy is subject to the
        Terms and Conditions of Use (TCU) posted by each Organization or Store
        (Organization) that you have opted to purchase, including the provisions
        regarding change or modification of this Privacy Policy and other policies as
        set forth in the TCU. Please check this page periodically for changes and
        updates to the Privacy Policy. This Privacy Policy is part of, and incorporated
      into, the TCU of your preferred and acceptable organization.</p>
      <p class=MsoNormal>The SHOP ACHAT secured website is not intended to be used by
        persons under the age of thirteen. Individuals who are under the age of
        thirteen are expressly prohibited from using or purchasing products or services
        through SHOP ACHAT website, Application and providing any personally identifiable
      information about themselves.</p>
      <p class=MsoNormal>By providing any personal information to this website, you
        fully understand and unambiguously consent to the collection, maintenance and
        processing of such information in Canada and/or any other country strictly for
        your participation with the Organization and SHOP ACHAT. In an outline we would
      like you to understand SHOP ACHAT's responsibilities and practices.</p>
      <p class=MsoNormal>The SHOP ACHAT and Organization’s SHOP ACHAT secured website
      allows you to:</p>
      <p class=MsoNormal>1. Create and administer your own SHOP ACHAT online account.
        You can opt in and manage your registered Organization’s Member Programs;
        points, dollars, visits, gift $ and many more accounts. Your access permits you
        to make purchases on line and accurately record, track, update any data, review
      reports and/or the results of such transactions.</p>
      <p class=MsoNormal>2. Process SHOP ACHAT and your Organization’s SHOP ACHAT
        Member Programs; points, dollars, visits, gift $ and many more accounts. This
        includes the issuance and redemption of points, dollars, reward visits, gift $,
        vouchers, coupons, products and/or additional service offerings to complete a
      purchase online, in store or through an Application.</p>
      <p class=MsoNormal>3. View and receive invoices from SHOP ACHAT or Participating
      Organizations’ or Partners’ accounts, as appropriate.</p>
      <p class=MsoNormal>4. Communicate information and offers to SHOP ACHAT, Members,
      Stores, Retailers, Suppliers, and Partners.</p>
      <p class=MsoNormal>The SHOP ACHAT and Organization’s SHOP ACHAT secured website
      allows them to:</p>
      <p class=MsoNormal>1. Understand and analyze you, Members' responses, needs and
      preferences.</p>
      <p class=MsoNormal>2. Develop, enhance market and/or provide products and
      services to meet those needs.</p>
      <p class=MsoNormal>3. Enable Members to participate in promotions and offers.
        From time to time, you may be asked to provide additional personal information.
        If you choose not to provide this information, it will not affect your ability
        to participate within any of the Organization’s SHOP ACHAT features and
      options.</p>
      <p class=MsoNormal>This Privacy Policy explains:</p>
      <p class=MsoNormal>1. What personal identifiable information SHOP ACHAT and its
        Organizations collect from you and how SHOP ACHAT and its Organizations use the
      information;</p>
      <p class=MsoNormal>2. With whom your information may be shared;</p>
      <p class=MsoNormal>3. What choices you have regarding the collection, use and
      distribution of your information;</p>
      <p class=MsoNormal>4. What cookies are and how SHOP ACHAT.com uses them;</p>
      <p class=MsoNormal>5. How SHOP ACHAT protects your personal information;</p>
      <p class=MsoNormal>6. How you can access, update or delete your information;
      and</p>
      <p class=MsoNormal>7. How you can contact us.</p>
      <p class=MsoNormal>1. What personal identifiable information SHOP ACHAT and its
        Organizations collect from you, and how SHOP ACHAT and its Organizations use
        the information. SHOP ACHAT collects and stores personal information in several
        ways at different parts of our program(s). This information may include your
        name, email address, mobile number, age, gender, address, areas of interest,
        User ID, User Password and other self-identifying information. We collect this
        information in order to provide you with our services more easily, and in a
        more personalized manner. We may make message boards and discussion forums
        available to you. If you choose to voluntarily disclose certain information on
        any such public area of the Program, this Privacy Policy will not cover such
        disclosure of information. We urge exercising caution when disclosing
        information on public message boards or discussion forums. SHOP ACHAT may also
        request certain information using online, mobile or direct mail order forms for
        products and services. On the activation, registration and order forms, we may
        collect contact information, demographic information, and method of payment and
        if applicable, a credit card number and any other information that your
        Organization wishes to capture. We may also collect information about you in
        surveys or for sweepstakes and contests on the website and information about
        the searches you perform and the pages you visit on the SHOP ACHAT.com site.
        SHOP ACHAT may also monitor, on an anonymous aggregate basis, patterns of use
        in connection with emails that it sends out, including which links are clicked
        on in our email and mobile communications, so that we may use such information
        to better personalize the content of the Program. All such information will be
        protected in accordance with our Privacy Policy. We may also automatically
        collect your Internet Protocol address to help diagnose problems and for system
        administration. SHOP ACHAT and its Organizations use the information collected
        from you in accordance with this Privacy Policy. Information we collect is used
        to customize your experience with our website. We also show you content that we
        think will be interesting to you, and display content according to the
        preferences you indicate while on our website. SHOP ACHAT may use your
        information to send you promotional materials about SHOP ACHAT and its
        Organizations or partners. We may also use your information to contact you, if
      necessary.</p>
      <p class=MsoNormal>2. With whom your information may be shared. SHOP ACHAT will
        not sell, rent or barter your personal information other than to its business
        partners as set forth herein. However, we may from time to time aggregate
        statistical information regarding our customers, purchasing and traffic
        patterns and site usage, or sell our research, which may contain aggregate
        information. In addition, we may report aggregate information to our
        advertisers. Such aggregate information will not individually identify any
      user.</p>
      <p class=MsoNormal>3. What choices you have regarding the collection, use and
        distribution of your information. You may occasionally receive information
        about the products or services you have selected to place on your personal
        profile, which may include SHOP ACHAT products and services, and the products
        and services of its Organizations. SHOP ACHAT believes that these updates are
        interesting and informative. Upon registering on the website, you will be given
        an opportunity to &quot;opt in&quot; to receive mailings from SHOP ACHAT and/or
        its Organizations by submitting the registration form. (For purposes of this
        Privacy Policy, &quot;partners&quot; include, in addition to third parties with
        whom SHOP ACHAT may have co-branding arrangements or some other business
        relationship or alliance, other parties and/or websites incubated or funded by
        SHOP ACHAT, as such term is defined below.) If you submit the registration form
        with the appropriate information, you thereby consent to being placed on this
        mailing list. You may subsequently contact us to request to be removed from
        this list. In every update that we send, we will include an option to
        discontinue receipt of future updates. SHOP ACHAT reserves the right to limit
        any registrations on our Program to those who will accept our information and
      to those who will provide the requested information.</p>
      <p class=MsoNormal>4. What cookies are, and how SHOP ACHAT uses them. As part
        of offering and providing customizable and personalized services, SHOP ACHAT
        uses cookies to store and sometimes track information about you. A cookie is a
        small amount of data that is transferred to your computer’s hard drive. All portions
        of the Site that prompt you to log in or that are customizable require that you
      accept cookies.</p>
      <p class=MsoNormal>No other company has access to cookies placed on your
        computer by SHOP ACHAT. We may use cookies technology to reduce the time
        required for you to submit your requests and for SHOP ACHAT to respond to such
        requests. Cookies will not be used by us to retrieve any information about you,
        or from your computer, that you have not voluntarily given to us. Cookies may
        also be placed on your computer when you link from the Site to our partners'
        web sites or when you click banner ads provided on our Site. Cookies placed on
        your computer by third parties by or through the Site, if any, are not the
        responsibility of SHOP ACHAT and are not subject to the TCU. Please contact the
        third party placing these cookies to find out what information is collected and
        how it is used. You can usually edit your browser not to accept cookies, but
        the features of our Site may not function properly if you do not accept
      cookies.</p>
      <p class=MsoNormal>5. How SHOP ACHAT protects your personal information. For
        all our transactions, we employ reasonable and current security methods and
        technologies. Where appropriate, we password protect, use encryption techniques
        and install firewalls. We strive to protect you. We encourage our participating
        service providers to adopt and <span class=SpellE>honor</span> their own
        consumer privacy policies. For all our efforts to safeguard your privacy, no
        system can be guaranteed. We cannot ensure or warrant the security of any
        information that you transmit to us, or that we transmit to you, or guarantee
        that it will be free from unauthorized access by third parties. Once we receive
        your information, we use reasonable efforts to ensure its security on our
      systems.</p>
      <p class=MsoNormal>6. How you can access, update or delete your information. As
        part of your use of the SHOP ACHAT Site (www.SHOPACHAT.ca), you are responsible
        for maintaining and updating, as applicable, your account Registration Data
        with current, accurate and complete information. You may view, update and/or
        edit the Registration Data you have provided to SHOP ACHAT and/or opt in or opt
        out of the different Organization’s programs by logging in to your profile and
      following the appropriate instructions.</p>
      <p class=MsoNormal>7. How you can contact us. Any questions about our Privacy
        Policy, the practices of the website, or your dealings with the SHOP ACHAT
        should be directed to: SHOP ACHAT Customer Service, 564-1804 BOUL. LE
        CORBUSIER, Laval, Quebec, <span class=GramE>Canada</span> H7S2N3 or by email at
      service.ca.</p>
      <p class=MsoNormal>8. File a complaint. You have the right to file a complaint
        with the applicable Privacy Commissioner about our collection and processing of
      personal information.</p>
      <p class=MsoNormal>{{ 'Policies.ContactInfo' | translate }}<br>SHOPACHAT<br>Attention: Privacy
        <br>340B Boul. Marcel-Laurin 2nd Floor<br>St.Laurent, Quebec<br>H4M 2L4<br>
        Privacy.ca<br>You can contact the SEEMYPASS Data Protection Officer
        <a href="/data-privacy-contact/en" target="_blank" rel="noopener noreferrer">here</a>
      </div>
    </ion-content>
  }

  @if (lang === 'fr' || lang === 'FR') {
    <ion-content>
      <div class=WordSection1>
        <p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'>Politique
        de confidentialité et Conditions d’utilisation</span></p>
        <p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'>INTRODUCTION</span></p>
        <p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'>SHOP ACHAT
          a créé le présent énoncé de confidentialité et de conditions d’utilisation pour
          démontrer son engagement soutenu envers le respect de votre vie privée et de
          vos activités en tant que membre actif et inscrit au site web sécurisé SHOP
          ACHAT. Les suivantes décrivent nos pratiques de collecte d’informations et de
        diffusion de renseignements pour le site web sécurisé SHOP ACHAT.</span></p>
        <p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'>SHOP ACHAT
          comprend et respecte vos préoccupations au sujet du respect de la vie privée.
          Nous vous demandons néanmoins de fournir des informations à votre sujet afin
          que nous puissions mieux comprendre vos besoins et bonifier votre expérience
          auprès de SHOP ACHAT. Nous avons créé la présente Politique de confidentialité
          pour vous faire part des informations que peut collecter SHOP ACHAT, de la
          manière que lesdites informations peuvent être utilisées et partagées avec des
          parties tierces, ainsi que des liens reliant lesdites informations à
          l’exploitation du Site. La présente Politique de confidentialité est assujettie
          aux Modalités et Conditions d’utilisation publiées par chaque Organisation ou
          Magasin (Organisation) à laquelle vous avez choisi de souscrire, y compris les
          dispositions concernant les changements ou les modifications à cette Politique
          de confidentialité et à d’autres politiques formulées dans les Modalités et
          Conditions d’utilisation. Veuillez consulter cette page périodiquement en cas
          de changements et de mises à jour à la Politique de confidentialité. La
          présente Politique de confidentialité fait partie des Modalités et Conditions
          d’utilisation de votre Organisation préférée et admissible, puis elle
        s’incorpore à cette dernière.</span></p>
<p class=MsoNormal><span class=tlid-translation><span lang=FR style='mso-ansi-language:
FR'>Le site sécurisé SHOP ACHAT n'est pas destiné à être utilisé par des
        personnes de moins de treize ans.</span> <span title="">Les personnes de moins
        de treize ans sont expressément interdites d'utiliser ou d'acheter des produits
        ou des services via le site Web de SHOP ACHAT, Application et de fournir des
      informations personnellement identifiables d’elles-mêmes.</span></span></p>
      <p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'>En
        fournissant des renseignements personnels à ce site web, vous signifiez que
        vous comprenez parfaitement et consentez sans aucune réserve à la collecte, au
        maintien et au traitement desdits renseignements au Canada et dans tout autre
        pays strictement dans le cadre de votre participation auprès de l’Organisation
        et de SHOP ACHAT. Permettez-nous de vous faire part des grandes lignes des
      responsabilités et des pratiques de SHOP ACHAT.</span></p>
      <p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'>Le site web
      sécurisé de SHOP ACHAT et de l’Organisation vous permet :</span></p>
      <p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'>1. De créer
        et d’administrer votre propre compte SHOP ACHAT en ligne. Vous pouvez adhérer à
        l’option de gérer les Programmes membres de votre Organisation inscrite; les
        points, les dollars, les visites, les dollars-cadeaux et plusieurs autres
comptes. </span><span class=tlid-translation><span lang=FR style='mso-ansi-language:
FR'>Votre accès vous permet d'effectuer des achats en ligne et d'enregistrer,
      de suivre, de mettre à jour avec précision toutes les données, d'examiner les
    rapports et / ou les résultats de ces transactions.</span></span></p>
    <p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'>2. De
      traiter les Programmes membres SHOP ACHAT et SHOP ACHAT de votre Organisation;
      les points, les dollars, les visites, les dollars-cadeaux et plusieurs autres
comptes. </span><span class=tlid-translation><span lang=FR style='mso-ansi-language:
FR'>Cela comprend l'émission et l'échange de points, de dollars, de récompenses
    de visites, de cartes-cadeaux, de bons, de coupons, de produits et / ou
    d'offres de services supplémentaires pour effectuer un achat en ligne, en
  magasin ou via une application.</span></span><span lang=FR-CA
style='background:yellow;mso-highlight:yellow;mso-ansi-language:FR-CA'></span></p>
<p class=MsoNormal><span class=tlid-translation><span lang=FR style='mso-ansi-language:
FR'>3. Affichez et recevez les factures des comptes SHOP ACHAT ou des
organisations participantes ou partenaires, selon le cas.</span></span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'>4. De
  communiquer les informations et les offres à SHOP ACHAT, aux membres, aux détaillants,
fournisseurs et aux partenaires.</span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'>Le site web
sécurisé de SHOP ACHAT et de l’Organisation les permet :</span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'>1. De
  comprendre et d’analyser les réponses, les besoins et les préférences des
Membres.</span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'>2. De
  développer ou d’améliorer le marché ou de fournir des produits et des services
pour satisfaire à ces besoins.</span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'>3. De
  permettre aux Membres de participer aux promotions et aux offres. De temps en
  temps, nous pourrions vous demander de fournir des renseignements personnels
  additionnels. Si vous décidez de ne pas fournir lesdits renseignements, ceci
  n’influera pas sur votre capacité à participer à toute fonction ou à toute
option SHOP ACHAT de l’Organisation.</span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'>&nbsp;</span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'>La présente
Politique de confidentialité explique :</span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'>&nbsp;</span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'>1. Les
  renseignements personnels précis que SHOP ACHAT et ses Organisations collectent
  de votre part et l’utilisation que font SHOP ACHAT et ses Organisations desdits
renseignements;</span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'>2. Les
parties avec lesquelles vos renseignements peuvent être partagés;</span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'>3. Vos
  choix quant à la collecte, à l’utilisation et à la distribution de vos
renseignements;</span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'>4. Ce que
  sont les témoins (cookies) et l’utilisation qu’en fait VOIRMAPPASSE (www.SHOP
ACHAT.com);</span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'>5. Comment SHOP
ACHAT protège vos renseignements personnels;</span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'>6. Comment
  vous pouvez accéder à vos renseignements, mettre ces derniers à jour ou les
supprimer;</span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'>7. Comment
vous pouvez prendre contact avec nous.</span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'></span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'>1. Les
  renseignements personnels précis que SHOP ACHAT et ses Organisations collectent
  de votre part et l’utilisation que font SHOP ACHAT et ses Organisations desdits
  renseignements. SHOP ACHAT collecte et stocke les renseignements personnels de
  plusieurs manières dans différents segments de notre ou nos Programmes. Ces
  renseignements peuvent inclure <span class=GramE>vos nom</span>, adresse de
  courriel, numéro de téléphone mobile, âge, sexe, adresse, centres d’intérêt, ID
  d’utilisateur, mot de passe d’utilisateur et autres renseignements permettant
  de vous identifier personnellement. Nous collectons ces renseignements afin de
  pouvoir vous fournir nos services plus aisément et d’une manière plus
  personnalisée. Il se peut que nous vous donnions accès à des babillards
  électroniques ou à des forums de discussion. Tout renseignement que ce soit que
  vous choisissez volontairement de divulguer dans toute zone publique du
  Programme n’est pas couvert par la présente Politique de confidentialité. Nous
  vous conseillons vivement de faire preuve de vigilance lorsque vous divulguez
  quelque information que ce soit sur un babillard électronique public ou un
  forum de discussion. En outre, il se peut que SHOP ACHAT vous demande certains
  renseignements ayant trait à des produits ou à des services, au moyen de bons
  de commande en ligne, mobiles ou par publipostage direct. Sur nos formulaires
  d’activation, d’inscription ou nos bons de commande, il se peut que nous vous
  demandions vos coordonnées, vos données démographiques, votre mode de paiement
  et, si applicable, votre numéro de carte de crédit et toute autre information
  que votre Organisation désire recueillir. Il se peut aussi que nous collections
  des renseignements à votre sujet dans des sondages ou aux fins de loterie ou de
  concours sur le site web, ainsi que des données au sujet des recherches que
  vous effectuez et des pages que vous visitez sur le site SHOP ACHAT.com. Il se
  peut aussi que SHOP ACHAT surveille, de manière anonyme et cumulative, vos
  habitudes d’utilisation par rapport à des courriels de la part de SHOP ACHAT, y
  compris les liens cliqués dans nos communications mobiles et par courriel, afin
  de nous permettre d’utiliser ces données pour mieux personnaliser le contenu du
  Programme. Tous ces renseignements seront protégés conformément à notre
  Politique de confidentialité. De plus, il se peut que nous recueillions automatiquement
  votre adresse IP (adresse de protocole Internet) afin de faciliter le
  diagnostic de problèmes et aux fins d’administration système. SHOP ACHAT et ses
  Organisations se servent des renseignements obtenus de votre part conformément
  à la présente Politique de confidentialité. Les renseignements que nous
  collectons sont utilisés pour personnaliser votre expérience en lien avec notre
  site web. Nous vous fournissons aussi du contenu qui selon nous est susceptible
  de vous intéresser, puis affichons pour vous du contenu conforme aux
  préférences que vous indiquez lorsque vous visitez notre site web. SHOP ACHAT
  peut se servir de vos renseignements pour vous envoyer du matériel promotionnel
  au sujet de SHOP ACHAT et de ses Organisations ou partenaires. Il se peut aussi
  que nous nous servions de vos renseignements pour prendre contact avec vous, si
nécessaire.</span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'></span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'></span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'>2. Les
  parties avec lesquelles vos renseignements peuvent être partagés. SHOP ACHAT ne
  vendra pas, de louera pas et ne fera pas de troc publicitaire avec vos
  renseignements personnels, sauf auprès de ses partenaires commerciaux en
  fonction des présentes. Cependant, il se peut que nous agrégions des
  informations statistiques de temps à autre au sujet de nos clients, de leurs
  habitudes d’achat, du trafic de données et de l’utilisation du site, voire que
  nous vendions nos recherches pouvant contenir des informations agrégées. Il se
  peut également que nous transmettions lesdites informations agrégées à nos
  annonceurs. De telles informations agrégées n’identifient aucun utilisateur de
manière individuelle.</span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'></span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'></span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'>3. Vos
  choix quant à la collecte, à l’utilisation et à la distribution de vos
  renseignements. Il se peut que vous receviez à l’occasion des informations au
  sujet des produits ou des services que vous avez choisi de placer sur votre
  profil personnel, y compris, mais sans s’y limiter, des produits et services SHOP
  ACHAT, ainsi que les produits et services de ses Organisations. SHOP ACHAT
  considère ces mises à jour comme intéressantes et informatives. Au moment de
  votre inscription au site web, vous vous verrez proposer l’option d’adhésion
  afin de recevoir des envois de la part de SHOP ACHAT ou de ses Organisations en
  soumettant le formulaire d’inscription. (Aux fins de la présente Politique de
  confidentialité, les « partenaires » incluent, en plus des parties tierces avec
  lesquelles SHOP ACHAT pourrait avoir conclu des ententes de <span class=SpellE>comarquage</span>
  ou toute autre relation commerciale ou alliance, d’autres parties ou sites web
  créés ou financés par SHOP ACHAT, conformément à la définition ci-dessous.) En
  soumettant le formulaire d’inscription comprenant les informations appropriées,
  vous consentez à être placé sur ladite liste d’envoi. Vous pouvez nous contacter
  ultérieurement pour nous demander de vous retirer de ladite liste. Dans chaque
  mise à jour que nous envoyons, nous inclurons une option d’empêcher la
  réception de mises à jour futures. SHOP ACHAT se réserve le droit de limiter
  l’inscription à son Programme à ceux qui accepteront les informations de sa
part et à ceux qui fourniront les informations demandées.</span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'></span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'>4. Ce que
  sont les témoins (cookies) et l’utilisation qu’en fait SHOP ACHAT. Dans le
  cadre de l’offre et de la prestation de services personnalisables et
  personnalisés, SHOP ACHAT a recours à des témoins (cookies) pour stocker et
  parfois répertorier des renseignements à propos de vous. Un témoin (cookie)
  représente une petite quantité de données qui est transférée au disque dur de
  votre ordinateur. Toutes les parties du Site qui vous invitent à vous connecter
ou qui sont personnalisables exigent que vous acceptiez les témoins (cookies).</span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'>Aucune
  autre entreprise n’a accès aux témoins (cookies) placés sur votre ordinateur
  par SHOP ACHAT. Il se peut que nous utilisions la technologie des témoins
  (cookies) pour réduire le temps requis lorsque vous soumettez vos demandes et
  le temps de réponse de SHOP ACHAT par rapport auxdites <span class=GramE>demandes</span>.
  Nous n’utiliserons pas les témoins (cookies) pour extraire quelconque
  information à votre sujet ni de votre ordinateur que vous ne nous avez pas
  fournie volontairement. Des témoins (cookies) peuvent aussi être placés sur
  votre ordinateur lorsque vous passez du Site à tout site de nos partenaires ou
  lorsque vous cliquez tout bandeau publicitaire s’affichant sur notre Site. SHOP
  ACHAT n’est pas responsable des témoins (cookies) placés sur votre ordinateur
  par des parties tierces au moyen du Site ou par l’intermédiaire de ce dernier,
  s’il y a lieu, et lesdits témoins (cookies) ne sont pas assujettis aux
  Modalités et Conditions d’utilisation. Veuillez contacter la ou les parties
  tierces ayant placé lesdits témoins (cookies) afin de connaître les
  informations recueillies et leur utilisation. Vous pouvez modifier les paramètres
  de votre navigateur afin que ce dernier n’accepte pas les témoins (cookies),
  mais il se peut que les fonctions de notre Site ne fonctionnent pas
correctement si vous n’acceptez pas les témoins (cookies).</span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'></span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'>5. Comment SHOP
  ACHAT protège vos renseignements personnels. Nous avons recours à des méthodes
  et à des technologies de sécurité raisonnables et actuelles pour toutes nos
  transactions. Le cas échéant, nous protégeons par mot de passe, utilisons des
  techniques de chiffrement et installons des pare-feu. Nous nous efforçons de
  vous protéger. Nous encourageons nos fournisseurs de services participants à
  adopter et à respecter leurs propres politiques de confidentialité des
  consommateurs. Malgré tous nos efforts visant la sauvegarde de votre vie
  privée, aucun système n’est garanti. Nous ne pouvons pas assurer ni garantir la
  sécurité des renseignements que vous nous transmettez ou que nous vous
  transmettons ni garantir que lesdits renseignements seront à l’abri d’un accès
  non autorisé par toute partie tierce. Une fois que nous recevons de
  l’information de votre part, nous consentons des efforts raisonnables afin
d’assurer sa sécurité dans nos systèmes.</span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'></span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'>6. Comment
  vous pouvez accéder à vos renseignements, mettre ces derniers à jour ou les
  supprimer. Dans le cadre de votre utilisation du site SHOP ACHAT (www.SHOPACHAT.ca),
  vous êtes responsable de maintenir et de mettre à jour, suivant le cas, vos
  données d’inscription de compte conformément aux renseignements actuels, exacts
  et exhaustifs. Vous pouvez afficher, mettre à jour ou modifier les données
  d’inscription que vous avez fournies à SHOP ACHAT, puis vous avez l’option
  d’adhérer ou de ne pas adhérer aux divers programmes de l’Organisation en vous
connectant à votre profil et en suivant les instructions appropriées.</span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'></span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'>7. Comment
  vous pouvez prendre contact avec nous. Veuillez adresser toute question au
  sujet de notre Politique de confidentialité, des pratiques de notre site web ou
  de vos démarches auprès de SHOP ACHAT au service à la clientèle VOIRMYPASSE, à
  l’ADRESSE postale SHOP ACHAT; 564-1804 BOUL. LE CORBUSIER, Laval, <span
class=SpellE>Quebec</span>, Canada H7S2N3 ou par courriel à
service.ca</span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'></span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'>8. Déposer
  une plainte. Vous avez le droit de déposer une plainte auprès du commissaire à la
  protection de confidentialité applicable concernant la collecte et le traitement
de vos informations personnelles.</span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'></span></p>
<p class=MsoNormal><span lang=FR-CA style='mso-ansi-language:FR-CA'>Informations
  de contact: SHOPACHAT Attention: Confidentialité 340B Boul.
  Marcel-Laurin 2ième étage St.Laurent, QCH4M 2L4 Privacy.ca Vous
  pouvez contacter le délégué à la protection des données de SHOPACHAT <a href="formLink"
target="data-privacy-contact-page">ici</a>.</span></p>
</div>
</ion-content>
}
